// extracted by mini-css-extract-plugin
export default {"container":"AddName_container__Rtrk0","input":"AddName_input__0APex"};